import { useState, type FormEvent } from "react";

import { signIn, signUp } from "../lib/api";

export function AuthScreen() {
  const [mode, setMode] = useState<"signin" | "signup">("signin");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setMessage(null);
    try {
      if (mode === "signin") {
        await signIn(email, password);
      } else {
        setMessage(await signUp(email, password));
      }
    } catch (error) {
      setMessage(error instanceof Error ? error.message : "Не удалось выполнить вход");
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="auth-page">
      <section className="auth-card panel">
        <span className="brand-mark">M1</span>
        <p className="panel-label">Finance M1</p>
        <h1>{mode === "signin" ? "Войдите в свои финансы" : "Создайте личное пространство"}</h1>
        <p className="auth-copy">Один аккаунт синхронизирует веб-версию на компьютере и телефоне.</p>
        <form onSubmit={submit} className="auth-form">
          <label>
            Почта
            <input type="email" autoComplete="email" required value={email} onChange={(event) => setEmail(event.target.value)} />
          </label>
          <label>
            Пароль
            <input
              type="password"
              autoComplete={mode === "signin" ? "current-password" : "new-password"}
              minLength={8}
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </label>
          {message && <p className="form-message">{message}</p>}
          <button className="confirm-primary" disabled={busy} type="submit">
            {busy ? "Подождите…" : mode === "signin" ? "Войти" : "Создать аккаунт"}
          </button>
        </form>
        <button
          className="auth-switch"
          type="button"
          onClick={() => {
            setMode(mode === "signin" ? "signup" : "signin");
            setMessage(null);
          }}
        >
          {mode === "signin" ? "Нет аккаунта? Зарегистрироваться" : "Уже есть аккаунт? Войти"}
        </button>
      </section>
    </main>
  );
}
